/* Back-to-top reveal.
   ES2019 only (FB/IG in-app WebViews) — no optional chaining / nullish coalescing.

   Shows only while the customer is scrolling UP. It used to appear the moment
   scrollY passed 300 and then stay there for the rest of the page, which parked
   a 48px button over the right edge of every section read on the way down — on
   the USP strip it covered a quarter of the "Fast delivery" label. Someone
   reading downward has not asked to go back to the top; someone scrolling up
   already has.

   The listener is passive and coalesced to one rAF per frame. The previous
   version wrote classes directly inside an unthrottled scroll handler, which is
   layout thrash on exactly the low-end Android where it costs most. */
(function () {
  var button = document.getElementById('scroll__top');
  if (!button) return;

  var MIN_OFFSET = 300; // nearer the top than this and the button earns nothing
  var JITTER = 4; // swallow sub-pixel drift and momentum wobble

  var lastY = window.scrollY || 0;
  var ticking = false;

  button.addEventListener('click', function () {
    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
  });

  function update() {
    ticking = false;
    var y = window.scrollY || 0;
    var delta = y - lastY;

    if (Math.abs(delta) < JITTER) return;
    lastY = y;

    if (delta < 0 && y > MIN_OFFSET) {
      button.classList.add('active');
    } else {
      button.classList.remove('active');
    }
  }

  window.addEventListener(
    'scroll',
    function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    },
    { passive: true }
  );
})();
